import { useMediaQuery } from "@material-ui/core";
import React from "react";
import { AutocompleteInput, Filter, ReferenceInput } from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import SearchInput from "../components/inputs/SearchInput";
import { usersConfig } from "../users";

const Filters = (props) => {
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<Filter {...props} variant="outlined">
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn={!sm}
				{...bookmakersConfig.reference}
				fullWidth
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				source="user_id"
				reference="users"
				{...usersConfig.reference}
				fullWidth
				alwaysOn={!sm}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
		</Filter>
	);
};
export default Filters;
